export const EditorColorsOptions = ['#4D9DE0', '#E15554', '#3ec3ef', '#E1BC29', '#3BB273', '#7768AE'];
export const EditorLineHeightOptions = [
    { label: '1', value: '1' },
    { label: '1.2', value: '1.2' },
    { label: '1.3', value: '1.3' },
    { label: '1.4', value: '1.4' },
    { label: '1.5', value: '1.5' },
    { label: '1.6', value: '1.6' },
    { label: '1.7', value: '1.7' },
    { label: '1.8', value: '1.8' },
    { label: '1.9', value: '1.9' },
    { label: '2', value: '2' },
];
export const EditorVariantOptions = [
    { label: 'VARIANT_Contained', value: 'contained' },
    { label: 'VARIANT_Outlined', value: 'outlined' },
];
export const EditorLinkTargetOptions = [
    { label: 'LINK_Target_Blank', value: '_blank' },
    { label: 'LINK_Target_Self', value: '_self' },
];
export const EditorLinkOpeningOptions = [
    { label: 'LINK_Opening_Type_Link', value: 'link' },
    { label: 'LINK_Opening_Type_Anchor', value: 'anchor' },
    { label: 'LINK_Opening_Type_Popup', value: 'popup' },
];
export const EditorSizeOptions = [
    { label: 'SIZE_Medium', value: 'md' },
    { label: 'SIZE_Large', value: 'lg' },
];
export const EditorRadiusOptions = [
    { label: '0', value: '0' },
    { label: '2', value: '2' },
    { label: '4', value: '4' },
    { label: '8', value: '8' },
];
export const EditorImageDisplayOptions = [
    { label: 'STYLE_Image_Display_As_Image', value: 'image' },
    { label: 'STYLE_Image_Display_As_Background', value: 'background' },
];
export const EditorBackgroundPositionOptions = [
    { label: 'STYLE_Background_Position_Center', value: 'center' },
    { label: 'STYLE_Background_Position_Top', value: 'top' },
    { label: 'STYLE_Background_Position_Left', value: 'left' },
    { label: 'STYLE_Background_Position_Right', value: 'right' },
    { label: 'STYLE_Background_Position_Bottom', value: 'bottom' },
];
export const EditorBackgroundSizeOptions = [
    { label: 'STYLE_Background_Size_Auto', value: 'auto' },
    { label: 'STYLE_Background_Size_Contain', value: 'contain' },
    { label: 'STYLE_Background_Size_Cover', value: 'cover' },
];
export const EditorHeadingOptions = [
    { label: 'h1', value: 'h1' },
    { label: 'h2', value: 'h2' },
    { label: 'h3', value: 'h3' },
    { label: 'h4', value: 'h4' },
    { label: 'h5', value: 'h5' },
    { label: 'h6', value: 'h6' },
];
export const EditorGapOptions = [
    { label: '0', value: '0' },
    { label: '2', value: '2' },
    { label: '4', value: '4' },
    { label: '6', value: '6' },
    { label: '8', value: '8' },
    { label: '10', value: '10' },
];
export const EditorGalleryImageNumberOptions = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
];
export const EditorGalleryHeightModeOptions = [
    { label: 'Auto', value: 'auto' },
    { label: 'Custom', value: 'custom' },
];
export const EditorFontSizeOptions = [
    { label: '10', value: '10' },
    { label: '12', value: '12' },
    { label: '14', value: '14' },
    { label: '16', value: '16' },
    { label: '18', value: '18' },
    { label: '20', value: '20' },
    { label: '22', value: '22' },
    { label: '24', value: '24' },
];
